module.exports = __webpack_public_path__ + "assets/disabled-d0d478.svg";